import { Stack, Typography, Chip } from "@mui/material";
import BoxItem from "../../../BoxItem";
import Item from "../../../Item";
export default function Motor({ data }) {
  return (
    <Stack>
      <Typography className="section-title">Força muscular</Typography>
      <Typography
        className="item-text color-blue-dark"
        fontSize="18px !important"
        fontWeight="500 !important"
        mt="20px"
        mb="20px"
      >
        Membros inferiores
      </Typography>
      <Stack className="template-grid column-4">
        <BoxItem
          label="Abdução das coxas"
          textRight={data.abducaoCoxasDireita}
          textLeft={data.abducaoCoxasEsquerda}
        />
        <BoxItem
          label="Flexão dos quadris"
          textRight={data.flexaoQuadrisDireita}
          textLeft={data.flexaoQuadrisEsquerda}
        />
        <BoxItem
          label="Extensão dos joelhos"
          textRight={data.extensaoCotovelosDireita}
          textLeft={data.extensaoJoelhosEsquerda}
        />
        <BoxItem
          label="Flexão dos joelhos"
          textRight={data.flexaoJoelhosDireita}
          textLeft={data.flexaoJoelhosEsquerda}
        />
        <BoxItem
          label="Dorsiflexão dos joelhos"
          textRight={data.dorsiflexaoJoelhosDireita}
          textLeft={data.dorsiflexaoJoelhosEsquerda}
        />
        <BoxItem
          label="Inversão dos pés"
          textRight={data.inversaoPesDireita}
          textLeft={data.inversaoPesEsquerda}
        />
        <BoxItem
          label="Flexão plantar dos pés"
          textRight={data.flexaoPlanarPesDireita}
          textLeft={data.flexaoPlanarPesEsquerda}
        />
        <BoxItem
          label="Flexão plantar dos pés"
          textRight={data.flexaoPlanarPesDireita}
          textLeft={data.flexaoPlanarPesEsquerda}
        />
      </Stack>
      <Typography
        className="item-text color-blue-dark"
        fontSize="18px !important"
        fontWeight="500 !important"
        mt="20px"
        mb="20px"
      >
        Membros superiores
      </Typography>
      <Stack className="template-grid column-4">
        <BoxItem
          label="Abdução das ombros"
          textRight={data.abducaoCoxasDireita}
          textLeft={data.abducaoOmbrosEsquerda}
        />
        <BoxItem
          label="Flexão dos cotovelos"
          textRight={data.flexaoCotovelosDireita}
          textLeft={data.flexaoCotovelosEsquerda}
        />
        <BoxItem
          label="Extensão dos cotovelos"
          textRight={data.extensaoCotovelosDireita}
          textLeft={data.extensaoCotovelosEsquerda}
        />
        <BoxItem
          label="Flexão dos punhos"
          textRight={data.flexaoPunhosDireita}
          textLeft={data.flexaoPunhosEsquerda}
        />
        <BoxItem
          label="Extensão dos dedos"
          textRight={data.extensaoDedosDireita}
          textLeft={data.extensaoDedosEsquerda}
        />
        <BoxItem
          label="Abdução dos 5 dedos"
          textRight={data.abducaoDedosDireita}
          textLeft={data.abducaoDedosEsquerda}
        />
        <BoxItem
          label="Abdução do polegar"
          textRight={data.abducaoPolegarDireita}
          textLeft={data.abducaoPolegarEsquerda}
        />
        <BoxItem
          label="Primeiro interosseo dorsal"
          textRight={data.primeiroInterosseoDorsalDireita}
          textLeft={data.primeiroInterosseoDorsalEsquerda}
        />
      </Stack>
      <Typography className="section-title">Atrofia muscular</Typography>
      <Stack className="template-grid column-4">
        <Item label="MID Proximal" text={data.MIDProximal} />
        <Item label="MID Distal" text={data.MIDDistal} />
        <Item label="MIE Proximal" text={data.MIEProximal} />
        <Item label="MIE Distal" text={data.MIEDistal} />
        <Item label="MSD Proximal" text={data.MSDProximal} />
        <Item label="MSD Distal" text={data.MSDDistal} />
        <Item label="MSE Proximal" text={data.MSEProximal} />
        <Item label="MSE Distal" text={data.MSEDistal} />
      </Stack>
      <Stack>
        <Item label="Fasciculações" text={data.fasciculacoesMotor} />
      </Stack>
      <Stack>
        <Typography
          className="item-text label color-blue-dark"
          mt="15px"
          mb="15px"
        >
          Fasciculações onde:
        </Typography>
      </Stack>

      <Stack className="container-chip">
        {data?.fasciculacoesMotorOnde.map(
          (value, index) =>
            value !== "" && <Chip className="chip" label={value} key={index} />
        )}
      </Stack>
      <Typography className="section-title">Tônus muscular:</Typography>
      <Stack className="template-grid column-4">
        <Item label="MSD" text={data.MSD} />
        <Item label="MSE" text={data.MSE} />
        <Item label="MID" text={data.MID} />
        <Item label="MIE" text={data.MIE} />
      </Stack>
      <Typography className="section-title">Reflexos profundos</Typography>
      <Stack className="template-grid column-4">
        <BoxItem
          label="Reflexo bicipital"
          textRight={data.reflexoBicipitalDireita}
          textLeft={data.reflexoBicipitalEsquerda}
        />
        <BoxItem
          label="Reflexo tricipital"
          textRight={data.reflexoTricipitalDireita}
          textLeft={data.reflexoTricipitalEsquerda}
        />
        <BoxItem
          label="Reflexo patelar"
          textRight={data.reflexoPatelarDireita}
          textLeft={data.reflexoPatelarEsquerda}
        />
        <BoxItem
          label="Reflexo aquileu"
          textRight={data.reflexoAquileuDireita}
          textLeft={data.reflexoAquileuEsquerda}
        />
      </Stack>
      <Typography className="section-title">Reflexos superficiais</Typography>
      <Stack className="template-grid column-4">
        <BoxItem
          label="Reflexo cutâneo-plantar"
          textRight={data.reflexoCutaneoDireita}
          textLeft={data.reflexoCutaneoEsquerda}
        />
        <BoxItem
          label="Sinal de hoffman"
          textRight={data.sinalDeHoffmannDireita}
          textLeft={data.sinalDeHoffmannEsquerda}
        />
        <Stack></Stack>
        <Stack></Stack>
      </Stack>
      <Stack className="template-grid column-4">
        <Item label="Tremor" text={data.tremor} />
        <Item label="Bradicinesia" text={data.bradicinesia} />
        <Item label="Ataxia" text={data.ataxia} />
        <Stack></Stack>
      </Stack>
    </Stack>
  );
}
